console.log("articles loaded.");
export default {
  header: "CISA News",
  view: "Article",
  articles: []
};
